// extracted by mini-css-extract-plugin
export default {"container":"pX-z","title":"qX-z","link":"rX-z"};